import printConfig from '../../../print-config.json'
import { Link } from 'react-router-dom'
import ButtonLink from '../../general/ButtonLink'

const ChooseFlyer = ({
    flyerData,
    week,
    basicUrl
}) => {
    const { flyers } = flyerData
    if(!flyers) {
        return ''
    }

    const pathnameAdd = `${basicUrl}/addItem/form`

    return (
        <div className="print-page print-format flyer site-content">
            <div>
                <div className='flyers-wrapper'>
                    {_.keys(flyers).map((flyerPk) => {
                        const flyer = flyers[flyerPk]
                        const {flyerSettings} = flyer
                        const format = printConfig.formats.A4landscapeFlyer
                        const {path, height, width, landscape} = format
                        const linkPath = `${basicUrl}/${path}/${flyerPk}/${landscape}/${week}`
                        
                        return (
                            <Link key={flyerPk} className={"format-link-wrapper"} to={linkPath}>
                                <div className="format-link-content">
                                    <div className="format-icon-wrapper">
                                        <div className={"icon"}>
                                            {flyerSettings.name && <p className="format-title title-large-light">{flyerSettings.name}</p>}
                                        </div>
                                    </div>
                                    <p className="format-dimensions text-light-uppercase">{width} x {height}</p>
                                </div>
                            </Link>
                        )
                    })}
                </div>

                {pathnameAdd && <ButtonLink
                    pathname={pathnameAdd}
                    className="button-add"
                    transId={"print_flyer_add_new_flyer"}
                    hideText={false}
                    />}
            </div>
        </div>
    )
}

export default ChooseFlyer